// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._3bpihDk8x{margin:0;background-color:var(--text-field);border-radius:2px;border:1px solid var(--text-field-outline);font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-size:15px;line-height:20px;outline:none;padding:9px 11px;-webkit-appearance:none;padding:0px;display:flex}._3bpihDk8x:focus{outline:none;box-shadow:0 0 0 3px var(--focus-color)}@media screen and (-ms-high-contrast: active){._3bpihDk8x:focus{outline:3px solid highlight}}._3bpihDk8x:focus{border-color:#4EA1E6}._3bpihDk8x[disabled],._3bpihDk8x[readonly]{background-color:var(--text-field-disabled);color:var(--secondary-text)}._3bpihDk8x>:first-child{white-space:nowrap;display:flex;align-items:center;padding-left:8px;color:var(--secondary-text)}._3bpihDk8x>:last-child{flex-grow:2}._3bpihDk8x input{border:0px;padding-left:0px}._3bpihDk8x input:focus{border:0px;box-shadow:none}._3VNNeP80x{border:1px solid rgba(0,111,200,0.8);box-shadow:0 0 4px rgba(10,65,110,0.4)}@media screen and (-ms-high-contrast: active){._3VNNeP80x{border:1px solid highlight}}._62uCUeoVx{font-size:14px}._4rN3WQLox{font-size:15px;border-color:#8f8f8f}._3dzmc7qDx{font-size:18px}._1LJH1iXzx{}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"wrapper": "_3bpihDk8x",
	"focused": "_3VNNeP80x",
	"small": "_62uCUeoVx",
	"normal": "_4rN3WQLox",
	"large": "_3dzmc7qDx",
	"label": "_1LJH1iXzx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["label"] + ""
};
module.exports = exports;
